/* eslint-disable no-underscore-dangle */
import * as Redux from 'redux'
import { connect } from 'react-redux'
import { ChangeEvent, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { FormControlLabel, Grid, RadioGroup } from '@mui/material'
import UploadFiles from '@Components/UploadFile/UploadFiles'
import RegroundAction from '@ClientActions/reground.action'
import { RegroundTypes } from '@ClientStores/client.action-types'
import ClientFirearmActions from '@ClientActions/firearm.action'
import ClassificationAction from '@ClientActions/classification.action'
import AccessoriesForm from '@Pages/Client/firearm/add-firearm/AccessoriesForm'
import { EClassifications } from '@Enum/classifications.enum'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import BaseButton from '@Components/Form/BaseButton/BaseButton'
import { BaseRadio } from '@Components/Form/BaseRadio/BaseRadio'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import UploadImage from '@Components/Form/UploadImage/UploadImage'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import { CommonService } from '@Services/common.service'
import { FormService } from '@Services/form.service'
import { MClassification } from '@Models/classification.model'
import { ICommonQuery } from '@Models/common.model'
import CustomTabs from '@Components/CustomTabs/CustomTabs/CustomTabs'
import TabPanel from '@Components/CustomTabs/TabPanel/TabPanel'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import PartsForm from './PartsForm'

interface IAddFirearm {
    getMakes: () => void
    getModels: (params: ICommonQuery) => void
    getSafeTypes: () => void
    getSafeSubTypes: (params?: any) => void
    getCities: (params: any) => void
    getStates: (params?: ICommonQuery) => void
    createFirearms?: (params: any) => Promise<any>
    updateFirearm?: (id: string, params: any) => Promise<any>
    makes?: MClassification[]
    models?: MClassification[]
    safeTypes?: MClassification[]
    safeSubTypes?: MClassification[]
    cities?: any
    states?: any
    userId?: string
    isDetailPage?: boolean
    productDetail?: any
    detailId?: string
    loading?: boolean
    isLoading?: any
    getClassificationsBySuggestion?: (params?: any) => void
    classifications?: any
}

const AddFirearm = (props: IAddFirearm) => {
    const {
        getMakes,
        getModels,
        getSafeTypes,
        getSafeSubTypes,
        getCities,
        getStates,
        createFirearms,
        updateFirearm,
        getClassificationsBySuggestion,
        makes,
        models,
        safeTypes,
        safeSubTypes,
        cities,
        states,
        userId,
        isDetailPage = false,
        productDetail,
        detailId,
        classifications,
    } = props

    // const [showAccessory, setShowAccessory] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    const [isClearAccessoryForm, setIsClearAccessoryForm] = useState(false)
    const [isClearPartForm, setIsClearPartForm] = useState(false)
    const [isShowActionBtn, setIsShowActionBtn] = useState(false)
    const tabs = ['Firearm', 'Accessory', 'Part']
    const [tab, setTab] = useState(0)

    const ac = new AbortController()

    const defaultValues: any = {
        product: {
            imageId: '',
            imageUrl: '',
            make: null,
            model: null,
            caliber: null,
            serial: '',
            fixedMagazine: 'false',
            roundCapacity: '',
            semiAuto: 'false',
            assaultWeapon: 'false',
            platform: null,
            type: null,
            loading: false,
        },
        productSeller: {
            file: {
                id: '',
                name: '',
                url: '',
            },
            ffl: '',
            businessName: '',
            dateOfPurchase: null,
            address: '',
            city: null,
            state: null,
            zipCode: '',
            loading: false,
        },
        accessory: {
            make: '',
            firearmModel: '',
            semiAuto: 'false',
            roundCapacity: '',
            caliber: '',
            dateOfPurchase: null,
            imageUrl: '',
            imageId: '',
            loading: false,
        },
        accessorySeller: {
            file: {
                id: '',
                name: '',
                url: '',
            },
            ffl: '',
            businessName: '',
            address: '',
            city: null,
            state: null,
            zipCode: '',
            loading: false,
        },
        partProduct: {
            component: null,
            serial: '',
            imageUrl: '',
            imageId: '',
            loading: false,
        },
        partSeller: {
            file: {
                id: '',
                name: '',
                url: '',
            },
            ffl: '',
            businessName: '',
            dateOfPurchase: null,
            address: '',
            city: null,
            state: null,
            zipCode: '',
            loading: false,
        },
    }
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        watch,
    } = useForm({ defaultValues })
    const watchProduct = watch('product')
    const watchSellerProduct = watch('productSeller')

    const handleSelectChange = (value: any, type: string) => {
        switch (type) {
            case 'PLATFORM': {
                setValue('product.type', null)
                break
            }
            case 'STATE': {
                setValue('productSeller.city', null)
                break
            }
            default:
                break
        }
    }

    const selectClassificationChange = (event: any, type: string) => {
        // const params
        switch (type) {
            case 'MAKE':
                setValue('product.model', null)
                setValue('product.caliber', null)
                break
            case 'MODEL':
                setValue('product.caliber', null)
                break
            default:
                break
        }
    }

    useEffect(() => {
        if (getClassificationsBySuggestion) getClassificationsBySuggestion()
        // getMakes()
        // getModels()
        getSafeTypes()
        getStates({ codes: 'CALIFORNIA' })
        reset()
    }, [])

    useEffect(() => {
        const params = {
            parentCode: watchProduct.platform,
        }
        getSafeSubTypes(params)
    }, [watchProduct?.platform])

    useEffect(() => {
        const params = {
            parentCode: watchSellerProduct.state,
        }
        getCities(params)
    }, [watchSellerProduct?.state])

    useEffect(() => {
        const params = {
            make: watchProduct?.make,
            model: watchProduct?.model,
            caliber: watchProduct?.caliber,
        }
        if (getClassificationsBySuggestion)
            getClassificationsBySuggestion(params)
    }, [watchProduct?.make, watchProduct?.model, watchProduct?.caliber])

    // get detail
    useEffect(() => {
        if (!productDetail) return

        // console.log(productDetail)
        if (productDetail?.type === 'FIREARM') {
            setValue('product', {
                imageId: productDetail?.imageId || '',
                imageUrl: productDetail?.imageUrl || '',
                make: productDetail?.make?.name,
                model: productDetail?.model?.name,
                caliber: productDetail?.caliber?.trim() || '',
                serial: productDetail?.serialCode?.trim() || '',
                fixedMagazine: productDetail?.isFixedMagazin ? 'true' : 'false',
                assaultWeapon: productDetail?.isAssaultWeapon
                    ? 'true'
                    : 'false',
                roundCapacity: productDetail?.capacity?.trim() || '',
                semiAuto: productDetail?.isSemiAutomatic ? 'true' : 'false',
                platform: productDetail?.safeType?.code || '',
                type: productDetail?.safeSubType?.code || '',
                loading: false,
            })
            setValue('productSeller', {
                file: {
                    id:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]?.fileId,
                    name:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]
                            ?.originalName,
                    url:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]?.fileUrl,
                },
                ffl: productDetail?.transactionDetail?.fflId?.trim() || '',
                businessName:
                    productDetail?.transactionDetail?.businessName?.trim() ||
                    '',
                dateOfPurchase: productDetail?.transactionDetail?.issuedAt
                    ? (new Date(
                          productDetail?.transactionDetail?.issuedAt
                      ) as any)
                    : null,
                address:
                    productDetail?.transactionDetail?.address?.trim() || '',
                city: productDetail?.transactionDetail?.city?.code || '',
                state: productDetail?.transactionDetail?.state?.code || '',
                zipCode:
                    productDetail?.transactionDetail?.zipCode?.trim() || '',
                loading: false,
            })
        }

        if (productDetail?.type === 'ACCESSORY') {
            // setIsClearAccessoryForm(false)
            setValue('accessory', {
                make: productDetail?.make?.name?.trim() || '',
                firearmModel: productDetail?.model?.name?.trim() || '',
                semiAuto: productDetail?.isSemiAutomatic ? 'true' : 'false',
                roundCapacity: productDetail?.capacity?.trim() || '',
                caliber: productDetail?.caliber?.trim() || '',
                dateOfPurchase: productDetail?.issuedAt
                    ? (new Date(productDetail?.issuedAt) as any)
                    : null,
                imageUrl: productDetail?.imageUrl || '',
                imageId: productDetail?.imageId || '',
                loading: false,
            })
            setValue('accessorySeller', {
                file: {
                    id:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]?.fileId,
                    name:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]
                            ?.originalName,
                    url:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]?.fileUrl,
                },
                ffl: productDetail?.transactionDetail?.fflId?.trim() || '',
                businessName:
                    productDetail?.transactionDetail?.businessName?.trim() ||
                    '',
                address:
                    productDetail?.transactionDetail?.address?.trim() || '',
                city: productDetail?.transactionDetail?.city?.code || '',
                state: productDetail?.transactionDetail?.state?.code || '',
                zipCode:
                    productDetail?.transactionDetail?.zipCode?.trim() || '',
                loading: false,
            })
        }
        if (productDetail?.type === 'PART') {
            setValue('partProduct', {
                component: productDetail?.component,
                serial: productDetail?.serialCode,
                imageUrl: productDetail?.imageUrl || '',
                imageId: productDetail?.imageId || '',
                loading: false,
            })
            setValue('partSeller', {
                file: {
                    id:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]?.fileId,
                    name:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]
                            ?.originalName,
                    url:
                        productDetail?.transactionDetail?.files?.length &&
                        productDetail?.transactionDetail?.files[0]?.fileUrl,
                },
                ffl: productDetail?.transactionDetail?.fflId?.trim() || '',
                businessName:
                    productDetail?.transactionDetail?.businessName?.trim() ||
                    '',
                dateOfPurchase: productDetail?.transactionDetail?.issuedAt
                    ? (new Date(
                          productDetail?.transactionDetail?.issuedAt
                      ) as any)
                    : null,
                address:
                    productDetail?.transactionDetail?.address?.trim() || '',
                city: productDetail?.transactionDetail?.city?.code || '',
                state: productDetail?.transactionDetail?.state?.code || '',
                zipCode:
                    productDetail?.transactionDetail?.zipCode?.trim() || '',
                loading: false,
            })
        }
    }, [productDetail])

    useEffect(() => {
        if (productDetail) {
            if (productDetail?.status !== 'BOUGHT' || undefined) {
                setIsShowActionBtn(false)
                setIsDisabled(true)
            } else {
                setIsShowActionBtn(true)
                setIsDisabled(false)
            }
        } else {
            setIsShowActionBtn(true)
            setIsDisabled(false)
        }
        if (productDetail?.type === 'ACCESSORY') {
            setTab(1)
        } else if (productDetail?.type === 'FIREARM') {
            setTab(0)
        } else if (productDetail?.type === 'PART') {
            setTab(2)
        }
    }, [productDetail])

    const onSubmit = (formData: any) => {
        // console.log(formData, 'formData')

        let body: any
        if (tab === 0) {
            const transactionDetail = {
                // type: 'BUY',
                fflId: formData.productSeller?.ffl,
                issuedAt:
                    formData.productSeller?.dateOfPurchase?.toISOString() || '',
                businessName: formData.productSeller?.businessName,
                address: formData.productSeller?.address,
                city: formData.productSeller?.city,
                state: formData.productSeller?.state,
                zipCode: formData.productSeller?.zipCode,
                files: formData.productSeller?.file?.id
                    ? [
                          {
                              fileId: formData.productSeller?.file?.id,
                              sequence: 1,
                              type: 'FILE',
                          },
                      ]
                    : '',
            }
            body = {
                serialCode: formData.product?.serial,
                userId,
                make: formData.product?.make?.__isNew__
                    ? formData.product?.make?.value
                    : formData.product?.make,
                model: formData.product?.model?.__isNew__
                    ? formData.product?.model?.value
                    : formData.product?.model,
                safeType: formData.product?.platform?.__isNew__
                    ? formData.product?.platform?.value
                    : formData.product?.platform,
                safeSubType: formData.product?.type?.__isNew__
                    ? formData.product?.type?.value
                    : formData.product?.type,
                capacity: formData.product?.roundCapacity,
                caliber: formData.product?.caliber?.__isNew__
                    ? formData.product?.caliber?.value
                    : formData.product?.caliber,
                type: 'FIREARM',
                imageId: formData.product?.imageId,
                isFixedMagazin:
                    formData.product?.fixedMagazine === 'true' ? 1 : 0,
                isSemiAutomatic: formData.product?.semiAuto === 'true' ? 1 : 0,
                transactionDetail,
                // subItems,
            }
        } else if (tab === 1) {
            const subItemTransDetail = {
                // type: 'BUY',
                fflId: formData.accessorySeller?.ffl,
                businessName: formData.accessorySeller?.businessName,
                address: formData.accessorySeller?.address,
                city: formData.accessorySeller?.city,
                state: formData.accessorySeller?.state,
                zipCode: formData.accessorySeller?.zipCode,
                files: formData.accessorySeller?.file?.id
                    ? [
                          {
                              fileId: formData.accessorySeller?.file?.id,
                              sequence: 1,
                              type: 'FILE',
                          },
                      ]
                    : '',
            }
            body = {
                capacity: formData.accessory?.roundCapacity,
                caliber: formData.accessory?.caliber,
                type: 'ACCESSORY',
                make: formData.accessory?.make,
                issuedAt:
                    formData.accessory?.dateOfPurchase?.toISOString() || '',
                model: formData.accessory?.firearmModel,
                transactionDetail: subItemTransDetail,
                imageId: formData.accessory?.imageId,
            }
        } else if (tab === 2) {
            const subItemTransDetail = {
                // type: 'BUY',
                issuedAt:
                    formData.partSeller?.dateOfPurchase?.toISOString() || '',
                fflId: formData.partSeller?.ffl,
                businessName: formData.partSeller?.businessName,
                address: formData.partSeller?.address,
                city: formData.partSeller?.city,
                state: formData.partSeller?.state,
                zipCode: formData.partSeller?.zipCode,
                files: formData.partSeller?.file?.id
                    ? [
                          {
                              fileId: formData.partSeller?.file?.id,
                              sequence: 1,
                              type: 'FILE',
                          },
                      ]
                    : '',
            }
            body = {
                serialCode: formData.partProduct?.serial,
                component: formData.partProduct?.component,
                type: 'PART',
                transactionDetail: subItemTransDetail,
                imageId: formData.partProduct?.imageId,
            }
        }

        if (tab === 0) {
            if (!formData.product?.imageId) delete body?.imageId
            if (!formData.productSeller?.file?.id)
                delete body?.transactionDetail?.files
            if (!formData.product?.serial) delete body?.serialCode
        } else if (tab === 1) {
            if (!formData.accessory?.imageId) delete body?.imageId
            if (!formData.accessorySeller?.file?.id)
                delete body?.transactionDetail?.files
        } else if (tab === 2) {
            if (!formData.partProduct?.imageId) delete body?.imageId
            if (!formData.partSeller?.file?.id)
                delete body?.transactionDetail?.files
        }

        if (isDetailPage && updateFirearm && detailId) {
            updateFirearm(detailId, body)
        } else if (!isDetailPage && createFirearms) {
            createFirearms(body).then(() => {
                reset(defaultValues)
            })
        }
    }

    const handleImageChange = (file: any, type: string) => {
        switch (type) {
            case 'PRODUCT':
                // setImageUrl(response?.url)
                setValue('product.loading', true)
                setValue('product.imageUrl', '')
                break

            case 'ACCESSORY':
                // setImageUrl(response?.url)
                setValue('accessory.loading', true)
                setValue('accessory.imageUrl', '')
                break
            case 'PART':
                // setImageUrl(response?.url)
                setValue('partProduct.loading', true)
                setValue('partProduct.imageUrl', '')
                break

            default:
                break
        }
        CommonService.uploadImage(file, false)
            .then((response: any) => {
                switch (type) {
                    case 'PRODUCT':
                        // setImageUrl(response?.url)
                        setValue('product.imageId', response?.id)
                        setValue('product.imageUrl', response?.url)
                        setValue('product.loading', false)
                        break
                    case 'ACCESSORY':
                        setValue('accessory.imageId', response?.id)
                        setValue('accessory.imageUrl', response?.url)
                        setValue('accessory.loading', false)
                        break
                    case 'PART':
                        setValue('partProduct.imageId', response?.id)
                        setValue('partProduct.imageUrl', response?.url)
                        setValue('partProduct.loading', false)
                        break

                    default:
                        break
                }
            })
            .catch(() => {
                // setValue('product.loading', false)
                switch (type) {
                    case 'PRODUCT':
                        setValue('product.loading', false)
                        break
                    case 'ACCESSORY':
                        setValue('accessory.loading', false)
                        break
                    case 'PART':
                        setValue('partProduct.loading', false)
                        break
                    default:
                        break
                }
            })
    }

    const onRemoveImage = (type: string) => {
        switch (type) {
            case 'PRODUCT':
                setValue('product.imageId', '')
                setValue('product.imageUrl', '')
                break

            case 'ACCESSORY':
                setValue('accessory.imageId', '')
                setValue('accessory.imageUrl', '')
                break

            case 'PART':
                setValue('partProduct.imageId', '')
                setValue('partProduct.imageUrl', '')
                break

            default:
                break
        }
    }

    const handleFileChange = (file: any, type: string) => {
        switch (type) {
            case 'PRODUCT_SELLER':
                setValue('productSeller.loading', true)
                setValue('productSeller.file​.name', '')
                break

            case 'ACCESSORY_SELLER':
                setValue('accessorySeller.loading', true)
                setValue('accessorySeller.file.name', '')
                break
            case 'PART_SELLER':
                setValue('partSeller.loading', true)
                setValue('partSeller.file.name', '')
                break

            default:
                break
        }
        CommonService.uploadFile(file)
            .then((response: any) => {
                switch (type) {
                    case 'PRODUCT_SELLER':
                        setValue('productSeller.loading', false)
                        setValue(
                            'productSeller.file.name',
                            response?.originalName
                        )
                        setValue('productSeller.file.url', response?.url)
                        setValue('productSeller.file.id', response?.id)
                        break

                    case 'ACCESSORY_SELLER':
                        setValue('accessorySeller.loading', false)
                        setValue(
                            'accessorySeller.file.name',
                            response?.originalName
                        )
                        setValue('accessorySeller.file.url', response?.url)
                        setValue('accessorySeller.file.id', response?.id)
                        break
                    case 'PART_SELLER':
                        setValue('partSeller.loading', false)
                        setValue('partSeller.file.name', response?.originalName)
                        setValue('partSeller.file.url', response?.url)
                        setValue('partSeller.file.id', response?.id)
                        break

                    default:
                        break
                }
            })
            .catch((uploadError) => {
                // setTempFile({})
                // setfileUploadLoading(false)
                switch (type) {
                    case 'PRODUCT_SELLER':
                        setValue('productSeller.loading', false)
                        setValue('productSeller.file.name', '')
                        break

                    case 'ACCESSORY_SELLER':
                        setValue('accessorySeller.loading', false)
                        setValue('accessorySeller.file.name', '')
                        break
                    case 'PART_SELLER':
                        setValue('partSeller.loading', false)
                        setValue('partSeller.file.name', '')
                        break

                    default:
                        break
                }
                console.log(uploadError)
            })
    }

    const handleRemoveFileUpload = (type: string) => {
        switch (type) {
            case 'PRODUCT_SELLER':
                setValue('productSeller.loading', false)
                setValue('productSeller.file.id', '')
                setValue('productSeller.file.name', '')
                setValue('productSeller.file.url', '')
                break

            case 'ACCESSORY_SELLER':
                setValue('accessorySeller.loading', false)
                setValue('accessorySeller.file.id', '')
                setValue('accessorySeller.file.name', '')
                setValue('accessorySeller.file.url', '')
                break
            case 'PART_SELLER':
                setValue('partSeller.loading', false)
                setValue('partSeller.file.id', '')
                setValue('partSeller.file.name', '')
                setValue('partSeller.file.url', '')
                break

            default:
                break
        }
    }

    useEffect(() => {
        return () => {
            ac.abort()
        }
    }, [])

    const handleTabChange = (
        event: React.ChangeEvent<any>,
        newValue: number
    ) => {
        setTab(newValue)
    }

    return (
        <>
            <div className="page-add-firearm page-custom-tabs">
                {!isDetailPage && <PageHeader title="Add Firearm" />}
                {!isDetailPage && (
                    <CustomTabs
                        tabs={tabs}
                        value={tab}
                        onChange={handleTabChange}
                        className="custom-tabs pb-4"
                    />
                )}

                <form onSubmit={handleSubmit(onSubmit)}>
                    <TabPanel value={tab} index={0}>
                        <div className="page-min-height">
                            <Grid container spacing={2}>
                                <Grid item sm={4} xs={12} className="pt-2">
                                    <UploadImage
                                        className="w-100 mb-2"
                                        style={{ height: 174 }}
                                        fileChanged={(e) => {
                                            handleImageChange(e, 'PRODUCT')
                                        }}
                                        imageUrl={watchProduct?.imageUrl}
                                        isLoading={watchProduct?.loading}
                                        type="upload-profile"
                                        id="upload-product-image"
                                        disabled={isDisabled}
                                        remove
                                        removeAction={() =>
                                            onRemoveImage('PRODUCT')
                                        }
                                    />
                                </Grid>
                                {/* right from */}
                                <Grid item sm={8} xs={12} container spacing={2}>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="product.make"
                                            defaultValue=""
                                            rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <BaseCreatableSelect
                                                    label="Make"
                                                    options={
                                                        classifications?.makes
                                                    }
                                                    value={value}
                                                    onChange={(event: any) => {
                                                        onChange(event)
                                                        // handleSelectChange(
                                                        //     event,
                                                        //     'MAKE'
                                                        // )
                                                        selectClassificationChange(
                                                            event,
                                                            'MAKE'
                                                        )
                                                    }}
                                                    fullWidth
                                                    error={
                                                        errors?.product?.make &&
                                                        true
                                                    }
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'product.make',
                                                        'Make'
                                                    )}
                                                    disabled={isDisabled}
                                                    isCreatable
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="product.model"
                                            defaultValue=""
                                            rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <BaseCreatableSelect
                                                    value={value}
                                                    onChange={(e: any) => {
                                                        onChange(e)
                                                        // onSelectedModel(e)
                                                        selectClassificationChange(
                                                            e,
                                                            'MODEL'
                                                        )
                                                    }}
                                                    options={
                                                        classifications?.models ||
                                                        []
                                                    }
                                                    label="Model"
                                                    fullWidth
                                                    disabled={isDisabled}
                                                    error={
                                                        errors?.product
                                                            ?.model && true
                                                    }
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'product.model',
                                                        'Model'
                                                    )}
                                                    isCreatable
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="product.caliber"
                                            defaultValue=""
                                            rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <BaseCreatableSelect
                                                    value={value}
                                                    onChange={(e: any) => {
                                                        onChange(e)
                                                        selectClassificationChange(
                                                            e,
                                                            'CALIBER'
                                                        )
                                                    }}
                                                    options={
                                                        classifications?.calibers ||
                                                        []
                                                    }
                                                    label="Caliber"
                                                    fullWidth
                                                    disabled={isDisabled}
                                                    error={
                                                        errors?.product
                                                            ?.caliber && true
                                                    }
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'product.caliber',
                                                        'Caliber'
                                                    )}
                                                    isCreatable
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="product.serial"
                                            defaultValue=""
                                            // rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <RedditTextField
                                                    {...field}
                                                    value={value}
                                                    onChange={onChange}
                                                    disabled={isDisabled}
                                                    label="Serial #"
                                                    className="reddit-input w-100"
                                                    variant="filled"
                                                    onKeyPress={(e: any) =>
                                                        CommonService.allowsInput(
                                                            e,
                                                            [
                                                                'alphabet',
                                                                'numeric',
                                                            ]
                                                        )
                                                    }
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <div className="page-gray-card radio-card">
                                            <p className="m-0 gray-text mr-2 w-50">
                                                Fixed Magazine
                                            </p>
                                            <Controller
                                                control={control}
                                                name="product.fixedMagazine"
                                                defaultValue=""
                                                render={({
                                                    field: { onChange, value },
                                                }) => (
                                                    // as={
                                                    <RadioGroup
                                                        className="d-flex flex-row align-items-center flex-nowrap"
                                                        value={value || 'false'}
                                                        onChange={(e) => {
                                                            onChange(e)
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            control={
                                                                <BaseRadio
                                                                    value="true"
                                                                    disabled={
                                                                        isDisabled
                                                                    }
                                                                />
                                                            }
                                                            label={
                                                                <span className="gray-text mr-2">
                                                                    YES
                                                                </span>
                                                            }
                                                            className="m-0"
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <BaseRadio
                                                                    value="false"
                                                                    disabled={
                                                                        isDisabled
                                                                    }
                                                                />
                                                            }
                                                            label={
                                                                <span className="gray-text mr-2">
                                                                    NO
                                                                </span>
                                                            }
                                                            className="m-0"
                                                        />
                                                    </RadioGroup>
                                                )}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="product.roundCapacity"
                                            defaultValue=""
                                            rules={{
                                                required: true,
                                                minLength: 1,
                                                maxLength: 3,
                                            }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <RedditTextField
                                                    {...field}
                                                    value={value}
                                                    onChange={onChange}
                                                    label="Round Capacity"
                                                    className="reddit-input w-100"
                                                    variant="filled"
                                                    disabled={isDisabled}
                                                    error={
                                                        errors?.product
                                                            ?.roundCapacity &&
                                                        true
                                                    }
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'product.roundCapacity',
                                                        'Round Capacity',
                                                        'Round Capacity should be 1 digit to 3 digit'
                                                    )}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <div className="page-gray-card radio-card">
                                            <p className="m-0 gray-text mr-2 w-50">
                                                Semi Automatic
                                            </p>
                                            <Controller
                                                control={control}
                                                name="product.semiAuto"
                                                defaultValue=""
                                                render={({
                                                    field: { onChange, value },
                                                }) => (
                                                    <RadioGroup
                                                        className="d-flex flex-row align-items-center flex-nowrap"
                                                        value={value || 'false'}
                                                        onChange={(e) => {
                                                            onChange(e)
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            control={
                                                                <BaseRadio
                                                                    value="true"
                                                                    disabled={
                                                                        isDisabled
                                                                    }
                                                                />
                                                            }
                                                            label={
                                                                <span className="gray-text mr-2">
                                                                    YES
                                                                </span>
                                                            }
                                                            className="m-0"
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <BaseRadio
                                                                    value="false"
                                                                    disabled={
                                                                        isDisabled
                                                                    }
                                                                />
                                                            }
                                                            label={
                                                                <span className="gray-text mr-2">
                                                                    NO
                                                                </span>
                                                            }
                                                            className="m-0"
                                                        />
                                                    </RadioGroup>
                                                )}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="product.platform"
                                            defaultValue=""
                                            rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <BaseCreatableSelect
                                                    value={value}
                                                    options={safeTypes || []}
                                                    onChange={(event: any) => {
                                                        onChange(event)
                                                        handleSelectChange(
                                                            event,
                                                            'PLATFORM'
                                                        )
                                                    }}
                                                    label="Platform"
                                                    fullWidth
                                                    disabled={isDisabled}
                                                    error={
                                                        errors?.product
                                                            ?.platform && true
                                                    }
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'product.platform',
                                                        'Platform'
                                                    )}
                                                    isCreatable
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <div className="page-gray-card radio-card">
                                            <p className="m-0 gray-text mr-2 w-50">
                                                Assault Weapon
                                            </p>
                                            <Controller
                                                control={control}
                                                name="product.assaultWeapon"
                                                defaultValue=""
                                                render={({
                                                    field: { onChange, value },
                                                }) => (
                                                    // as={
                                                    <RadioGroup
                                                        className="d-flex flex-row align-items-center flex-nowrap"
                                                        value={value || 'false'}
                                                        onChange={(e) => {
                                                            onChange(e)
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            control={
                                                                <BaseRadio
                                                                    value="true"
                                                                    disabled={
                                                                        isDisabled
                                                                    }
                                                                />
                                                            }
                                                            label={
                                                                <span className="gray-text mr-2">
                                                                    YES
                                                                </span>
                                                            }
                                                            className="m-0"
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <BaseRadio
                                                                    value="false"
                                                                    disabled={
                                                                        isDisabled
                                                                    }
                                                                />
                                                            }
                                                            label={
                                                                <span className="gray-text mr-2">
                                                                    NO
                                                                </span>
                                                            }
                                                            className="m-0"
                                                        />
                                                    </RadioGroup>
                                                )}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="product.type"
                                            defaultValue=""
                                            // rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <BaseCreatableSelect
                                                    value={value}
                                                    onChange={onChange}
                                                    options={safeSubTypes || []}
                                                    label="Type"
                                                    fullWidth
                                                    disabled={
                                                        isDisabled ||
                                                        !watchProduct?.platform
                                                    }
                                                    isCreatable
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <p className="page-title mt-5 w-100 ml-3">
                                        {productDetail?.status === 'SOLD' ||
                                        productDetail?.status === 'STOLEN'
                                            ? 'Buyer Details'
                                            : 'Seller Details'}
                                    </p>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="productSeller.ffl"
                                            defaultValue=""
                                            // rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <RedditTextField
                                                    {...field}
                                                    value={value}
                                                    onChange={onChange}
                                                    label="FFL #"
                                                    className="reddit-input w-100"
                                                    variant="filled"
                                                    disabled={isDisabled}
                                                    onKeyPress={(e: any) =>
                                                        CommonService.allowsInput(
                                                            e,
                                                            [
                                                                'alphabet',
                                                                'space',
                                                                'numeric',
                                                            ]
                                                        )
                                                    }
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="productSeller.businessName"
                                            defaultValue=""
                                            // rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <RedditTextField
                                                    {...field}
                                                    value={value}
                                                    onChange={onChange}
                                                    label="Business Name"
                                                    className="reddit-input w-100"
                                                    variant="filled"
                                                    disabled={isDisabled}
                                                    onKeyPress={(e: any) =>
                                                        CommonService.allowsInput(
                                                            e,
                                                            [
                                                                'alphabet',
                                                                'space',
                                                                'numeric',
                                                            ]
                                                        )
                                                    }
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="productSeller.dateOfPurchase"
                                            defaultValue={null}
                                            // rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <BaseDatePicker
                                                    {...field}
                                                    label="Date of Purchase"
                                                    onChange={(e: any) => {
                                                        onChange(e)
                                                    }}
                                                    value={value}
                                                    fullWidth
                                                    inputRef={ref}
                                                    maxDate={new Date()}
                                                    disabled={isDisabled}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="productSeller.address"
                                            defaultValue=""
                                            // rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <RedditTextField
                                                    {...field}
                                                    value={value}
                                                    onChange={onChange}
                                                    label="Address"
                                                    className="reddit-input w-100"
                                                    variant="filled"
                                                    disabled={isDisabled}
                                                    onKeyPress={(e: any) =>
                                                        CommonService.allowsInput(
                                                            e,
                                                            [
                                                                'alphabet',
                                                                'space',
                                                                'numeric',
                                                            ]
                                                        )
                                                    }
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12} className="pt-2">
                                        {/* image */}

                                        <UploadFiles
                                            style={{ height: '168px' }}
                                            remove
                                            fileChanged={(e: string) =>
                                                handleFileChange(
                                                    e,
                                                    'PRODUCT_SELLER'
                                                )
                                            }
                                            isLoading={
                                                watchSellerProduct?.loading
                                            }
                                            filename={
                                                watchSellerProduct?.file?.name
                                            }
                                            fileUrl={
                                                watchSellerProduct?.file?.url
                                            }
                                            removeAction={() =>
                                                handleRemoveFileUpload(
                                                    'PRODUCT_SELLER'
                                                )
                                            }
                                        />
                                    </Grid>

                                    <Grid item sm={6} xs={12} className="pt-2">
                                        <Controller
                                            control={control}
                                            name="productSeller.state"
                                            defaultValue=""
                                            // rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <BaseCreatableSelect
                                                    className="mb-2"
                                                    value={value}
                                                    onChange={(event: any) => {
                                                        onChange(event)
                                                        handleSelectChange(
                                                            event,
                                                            'STATE'
                                                        )
                                                    }}
                                                    options={states}
                                                    label="State"
                                                    fullWidth
                                                    disabled={isDisabled}
                                                />
                                            )}
                                        />

                                        <Controller
                                            control={control}
                                            name="productSeller.city"
                                            defaultValue=""
                                            // rules={{ required: true }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <BaseCreatableSelect
                                                    className="mb-2"
                                                    value={value}
                                                    onChange={onChange}
                                                    options={cities}
                                                    label="City"
                                                    fullWidth
                                                    disabled={
                                                        isDisabled ||
                                                        !watchSellerProduct?.state
                                                    }
                                                />
                                            )}
                                        />

                                        <Controller
                                            control={control}
                                            name="productSeller.zipCode"
                                            defaultValue=""
                                            rules={{
                                                minLength: 1,
                                                maxLength: 5,
                                            }}
                                            render={({
                                                field: {
                                                    ref,
                                                    value,
                                                    onChange,
                                                    ...field
                                                },
                                            }: any) => (
                                                <RedditTextField
                                                    {...field}
                                                    value={value}
                                                    onChange={onChange}
                                                    label="Zip Code"
                                                    className="reddit-input w-100"
                                                    variant="filled"
                                                    error={
                                                        errors?.productSeller
                                                            ?.zipCode && true
                                                    }
                                                    disabled={isDisabled}
                                                    helperText={FormService.getErrorMessage(
                                                        errors,
                                                        'productSeller.zipCode',
                                                        'Zip Code',
                                                        'Zip Code should be 1 to 5 digit'
                                                    )}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </TabPanel>
                    {/* Accessory Form */}
                    <TabPanel value={tab} index={1}>
                        <AccessoriesForm
                            control={control}
                            errors={errors}
                            watch={watch}
                            reset={reset}
                            setValue={setValue}
                            imageChanged={(e: string, type) =>
                                handleImageChange(e, type)
                            }
                            fileChanged={(e: string, type) =>
                                handleFileChange(e, type)
                            }
                            onRemoveImg={(type) => onRemoveImage(type)}
                            removeFileUpload={(type) =>
                                handleRemoveFileUpload(type)
                            }
                            isDetailPage={isDetailPage}
                            isDisabled={isDisabled}
                            isClearAccessoryForm={isClearAccessoryForm}
                            productDetail={productDetail}
                        />
                    </TabPanel>
                    <TabPanel value={tab} index={2}>
                        <PartsForm
                            control={control}
                            errors={errors}
                            watch={watch}
                            reset={reset}
                            setValue={setValue}
                            imageChanged={(e: string, type) =>
                                handleImageChange(e, type)
                            }
                            fileChanged={(e: string, type) =>
                                handleFileChange(e, type)
                            }
                            onRemoveImg={(type) => onRemoveImage(type)}
                            removeFileUpload={(type) =>
                                handleRemoveFileUpload(type)
                            }
                            isDetailPage={isDetailPage}
                            isDisabled={isDisabled}
                            isClearPartForm={isClearPartForm}
                            productDetail={productDetail}
                        />
                    </TabPanel>

                    {isShowActionBtn && (
                        <>
                            <div className="page-divider my-3" />
                            <div className="text-right">
                                <BaseButton
                                    type="submit"
                                    className="variant-red btn-lg-width"
                                >
                                    Save
                                </BaseButton>
                            </div>
                        </>
                    )}
                </form>
            </div>
        </>
    )
}

const mapStateToProps = (store: any) => {
    const { makes, models, safeTypes, safeSubTypes, classifications } =
        store?.client.classifications
    return {
        makes,
        models,
        // safeTypes,
        // safeSubTypes,
        safeTypes: safeTypes.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        safeSubTypes: safeSubTypes.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        cities: store?.client.regrounds?.cities.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        states: store?.client.regrounds?.states.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        userId: store?.auth?.user?.id,
        classifications,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getClassifications } = ClassificationAction
    const { MAKE, MODEL, SAFE_TYPE, SAFE_SUB_TYPE } = EClassifications
    return {
        getMakes: () => dispatch(getClassifications(MAKE) as any),
        getModels: (params: ICommonQuery) =>
            dispatch(getClassifications(MODEL, params) as any),
        getSafeTypes: () => dispatch(getClassifications(SAFE_TYPE) as any),
        getSafeSubTypes: (params: any) =>
            dispatch(getClassifications(SAFE_SUB_TYPE, params) as any),
        getStates: (params?: ICommonQuery) =>
            dispatch(
                RegroundAction.getReground(
                    'STATE',
                    RegroundTypes.STATE,
                    params
                ) as any
            ),
        getCities: (params: any) =>
            dispatch(
                RegroundAction.getReground(
                    'CITY',
                    RegroundTypes.CITY,
                    params
                ) as any
            ),
        createFirearms: (body: any) =>
            dispatch(ClientFirearmActions.createFirearms(body) as any),
        updateFirearm: (id: string, body: any) =>
            dispatch(ClientFirearmActions.updateFirearm(id, body) as any),
        getClassificationsBySuggestion: (params: any) =>
            dispatch(
                ClassificationAction.getClassificationsBySuggestion(
                    params
                ) as any
            ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFirearm)
